import { render, staticRenderFns } from "./new-manually.vue?vue&type=template&id=b868fb70&"
import script from "./new-manually.vue?vue&type=script&lang=js&"
export * from "./new-manually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports